import axios from '../../axios';
import { UpdateCurrentUserPassword } from '../currentuser';
import * as models from '../models';

export function CreateUser(user: models.IUser): Promise<void> {
    return axios.post('/v2/users', new models.User(user)).then(() => undefined);
}

// SetPasswordOnLogin saves the password the customer typed once they sign in
// with the login code just sent, so a password is only set on an account whose
// owner has proven they hold its email. The returned login settles after the
// password is saved, and rejects when either step fails.
export function SetPasswordOnLogin<T extends { login: Promise<unknown> }>(prompt: T, password: string): T {
    return {
        ...prompt,
        login: prompt.login.then(() => UpdateCurrentUserPassword({ newPassword: password, confirmPassword: password })),
    };
}
